import { api } from '../core';
import { handleQueryLifecycle } from '../utils';

/**
 * One entry per allegation document on the case. Returned by the case-
 * scoped `case/allegation/get-download` endpoint, which the sidebar uses
 * to hydrate every document's signed download URL in a single call.
 */
export interface CaseAllegationGetDownloadNode {
  allegationDocumentId: string;
  allegationDocumentName: string;
  downloadPath: string;
  downloadToken: string;
}

export interface CaseAllegationGetDownloadResponse {
  nodes: CaseAllegationGetDownloadNode[];
}

interface CaseAllegationGetDownloadProps {
  caseId: string;
}

const caseAllegationGetDownloadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCaseAllegationDownload: builder.query<CaseAllegationGetDownloadResponse, CaseAllegationGetDownloadProps>({
      query: ({ caseId }) => ({
        url: `case/allegation/get-download?case_id=${caseId}`,
        method: 'GET',
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryLifecycle(queryFulfilled, 'getCaseAllegationDownload');
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyGetCaseAllegationDownloadQuery } = caseAllegationGetDownloadApi;
